import { takeLatest, call, put } from 'redux-saga/effects';
import { campaignsListMapper } from 'utils/functions/dataMapper';

import { getCampaignsList, getCampaignInfo, addCampaign, editCampaign } from './api';
import {
  fetchCampaignsListSuccess,
  fetchCampaignsListFail,
  fetchCampaignInfoSuccess,
  fetchCampaignInfoFail,
  fetchAddOrEditCampaignSubmissionSuccess,
  fetchAddOrEditCampaignSubmissionFail,
} from './actions';
import campaignsActionTypes from './action-types';

function* fetchCampaignsListSaga({ payload }) {
  try {
    const response = yield call(getCampaignsList, payload);
    const mappedCampaigns = {
      ...response.data.data,
      results: campaignsListMapper(response.data.data.results),
    };

    yield put(fetchCampaignsListSuccess(mappedCampaigns));
  } catch (error) {
    yield put(fetchCampaignsListFail(error));
  }
}

function* fetchCampaignInfoSaga({ payload }) {
  try {
    const response = yield call(getCampaignInfo, payload);
    yield put(fetchCampaignInfoSuccess(response.data.data));
  } catch (error) {
    yield put(fetchCampaignInfoFail(error));
  }
}

function* fetchAddOrEditCampaignSubmissionSaga({ payload }) {
  const { addOrEditCampaignCallbackActionSuccess, actionPopupCallbackAction } = payload;

  try {
    const { campaignKey } = payload;

    if (campaignKey) yield call(editCampaign, payload);
    else yield call(addCampaign, payload);

    if (addOrEditCampaignCallbackActionSuccess) addOrEditCampaignCallbackActionSuccess();
    if (actionPopupCallbackAction) actionPopupCallbackAction(true);
    yield put(fetchAddOrEditCampaignSubmissionSuccess());
  } catch (error) {
    if (actionPopupCallbackAction) actionPopupCallbackAction();
    yield put(fetchAddOrEditCampaignSubmissionFail(error));
  }
}

function* campaignsSaga() {
  yield takeLatest(campaignsActionTypes.FETCH_CAMPAIGNS_LIST, fetchCampaignsListSaga);
  yield takeLatest(campaignsActionTypes.FETCH_CAMPAIGN_INFO, fetchCampaignInfoSaga);
  yield takeLatest(
    campaignsActionTypes.FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION,
    fetchAddOrEditCampaignSubmissionSaga,
  );
}

export default campaignsSaga;
